export const PRICE_MODES ={
  ON : 'On',
  RANGE : 'Range',
  OFF : 'Off'
};